<template>
  <table class="radio-btn-set radio-btn-set-left">
    <tbody>
      <tr>
        <td v-for="(option, idx) in measurementSystems" :key="idx">
          <input
            type="radio"
            :value="option"
            :id="getOptionId(option)"
            :checked="option == value"
            @input="$emit('input', option)"
          />
          <label :for="getOptionId(option)">{{ getLabelForSystem(option) }}</label>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { MeasurementSystem } from "../../../types";

export type MeasurementType = "height" | "weight";

export default Vue.extend({
  props: {
    value: { type: String as PropType<MeasurementSystem>, required: true },
    measurementSystems: { type: Array as PropType<MeasurementSystem[]>, required: true },
    type: { type: String as PropType<MeasurementType>, required: true },
  },
  methods: {
    getLabelForSystem(system: MeasurementSystem) {
      switch (system) {
        case "Metric":
          return this.type === "height" ? "cm" : "kg";
        case "UsCustomary":
        case "UsImperial":
          return this.type === "height" ? "feet/inches" : "pounds";
        case "Imperial":
          return this.type === "height" ? "feet/inches" : "stones/pounds";
      }
    },
    getOptionId(option: MeasurementSystem) {
      return `option-${this.type}-${option}`;
    },
  },
});
</script>
